import { frontendURL } from 'dashboard/helper/URLHelper.js';
import Inicio from './pages/Inicio.vue';
import Montar from './pages/Montar.vue';
import Prompt from './pages/Prompt.vue';
import Habilidades from './pages/Habilidades.vue';
import Comportamento from './pages/Comportamento.vue';
import Caixas from './pages/Caixas.vue';
import Testar from './pages/Testar.vue';
import Base from './pages/Base.vue';
import Chaves from './pages/Chaves.vue';
import Conversas from './pages/Conversas.vue';
import Claude from './pages/Claude.vue';
import Operador from './pages/Operador.vue';
import Plano from './pages/Plano.vue';
import Oferta from './pages/Oferta.vue';

// Agente de IA (SPEC-03 de docs/atende-ia). So administrador; o item do menu
// aparece quando o Super Admin liga o modulo (account.settings.ia_enabled).
const meta = { permissions: ['administrator'] };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agente-ia'),
    name: 'agente_ia_inicio',
    meta,
    component: Inicio,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia/montar'),
    name: 'agente_ia_montar',
    meta,
    component: Montar,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia/o-que-leu'),
    name: 'agente_ia_prompt',
    meta,
    component: Prompt,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia/habilidades'),
    name: 'agente_ia_habilidades',
    meta,
    component: Habilidades,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia/comportamento'),
    name: 'agente_ia_comportamento',
    meta,
    component: Comportamento,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia/testar'),
    name: 'agente_ia_testar',
    meta,
    component: Testar,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia/caixas'),
    name: 'agente_ia_caixas',
    meta,
    component: Caixas,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia/operador'),
    name: 'agente_ia_operador',
    meta,
    component: Operador,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia/base'),
    name: 'agente_ia_base',
    meta,
    component: Base,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia/chaves'),
    name: 'agente_ia_chaves',
    meta,
    component: Chaves,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia/conversas'),
    name: 'agente_ia_conversas',
    meta,
    component: Conversas,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia/claude-code'),
    name: 'agente_ia_claude',
    meta,
    component: Claude,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia/plano'),
    name: 'agente_ia_plano',
    meta,
    component: Plano,
  },
  {
    path: frontendURL('accounts/:accountId/agente-ia-oferta'),
    name: 'agente_ia_oferta',
    meta,
    component: Oferta,
  },
];
